import { EditTermModal } from 'features/community/components/modal/edit-term-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
// ../components/modal/edit-term-modal
export const GroupTermViewEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.COMMUNITY_TC);
  };

  return <EditTermModal id={id} onClose={closeModal} onSuccess={closeModal} />;
};
